import * as React from "react"
import {
  ReactNode,
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

type AuthTokens = {
  token: string;
  refresh_token: string;
};

const AUTH_TOKENS_KEY = "AUTHENTICATION_TOKEN";

export const AuthContext = createContext({
  login: (authTokens: AuthTokens) => {},
  logout: () => {},
  isLoggedIn: false,
  authTokens:{token:null},
});

export default function AuthContextProvider({
  children,
}: {
  children: ReactNode;
}) {

  var authTokensInLocalStorage = null;
  if (typeof window !== "undefined") {
     authTokensInLocalStorage = window.localStorage.getItem(AUTH_TOKENS_KEY);
  }
  const [authTokens, setAuthTokens] = useState(
    authTokensInLocalStorage === null
      ? {token:null}
      : JSON.parse(authTokensInLocalStorage)
  );

  const login = useCallback((authTokens: AuthTokens) => {
    console.log("Intentando hacer login con", authTokens);
    if (typeof window !== "undefined" && authTokens) {
      window.localStorage.setItem(AUTH_TOKENS_KEY, JSON.stringify(authTokens));
    }
    setAuthTokens(authTokens);
  }, []);

  const logout = useCallback(function () {
    if (typeof window !== "undefined") {
		  window.localStorage.removeItem(AUTH_TOKENS_KEY);
    }
    setAuthTokens({token:null});
  }, []);

  const value = useMemo(
    () => ({
      login,
      logout,
      authTokens,
      isLoggedIn: authTokens.token !== null,
    }),
    [authTokens, login, logout]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuthContext() {
  return useContext(AuthContext);
}